import { render, staticRenderFns } from "./Aboutourservices.vue?vue&type=template&id=141da2b0&scoped=true"
import script from "./Aboutourservices.vue?vue&type=script&lang=js"
export * from "./Aboutourservices.vue?vue&type=script&lang=js"
import style0 from "./Aboutourservices.vue?vue&type=style&index=0&id=141da2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141da2b0",
  null
  
)

export default component.exports